import { createSlice } from '@reduxjs/toolkit';
import { userService } from '../services/users.service';
import { openSnackBar } from './snackBarReducer';
import { setUser } from './userReducer';
import { clearAuthToken, getAuthToken, setAuthToken } from '../utils/authToken';

const initialToken = getAuthToken();

//reducers
export const authSlice = createSlice({
    name: 'authentication',
    initialState: {
        loggingIn: false,
        loggedIn: initialToken ? true : false,
        userToken: initialToken,
        registering: false
    },
    reducers: {
        loginRequest: (state) => {
            state.loggingIn = true
        },
        loginSuccess: (state, action) => {
            state.loggingIn = false;
            state.loggedIn = true;
            // action.payload is the JWT string (not the whole response object)
            state.userToken = action.payload;
            setAuthToken(action.payload);
        },
        loginFailure: (state) => {
            state.loggingIn = false;
            state.loggedIn = false;
        },
        registerRequest: (state) => {
            state.registering = true;
        },
        registerEnd: (state) => {
            state.registering = false;
        },
        logout: (state) => {
            clearAuthToken();
            state.loggedIn = false;
            state.userToken = null;
        }
    }
});

//actions
export const { loginRequest, loginSuccess, loginFailure, registerRequest, registerEnd, logout } = authSlice.actions;

export const logoutRequest = () => async (dispatch) => {
    try {
        await userService.logout();
        dispatch(logout());
        dispatch(setUser({}))
        dispatch(openSnackBar({ message: 'Successfully sign out', status: 'success' }))
    }  catch (error) {
        dispatch(openSnackBar({ message: error.message, status: 'error' }))
    }
};

export const logUserIn = (email, password, from, navigate) => async (dispatch) => {
    dispatch(loginRequest());

    try {
        const respData = await userService.login(email, password);
        const token = respData && respData.data && respData.data.token;
        const user = respData && respData.data && respData.data.user;
        if (!token || !user) {
            throw new Error('Login response was missing a token or user. Please try again.');
        }
        dispatch(loginSuccess(token));
        dispatch(setUser(user));
        const username = `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.email;
        dispatch(openSnackBar({ message: `Hello ${username}!`, status: 'info' }));
        if (typeof navigate === 'function') {
            navigate(from || '/explore', { replace: true });
        }
    } catch (error) {
        dispatch(loginFailure())
        dispatch(openSnackBar({ message: error.message, status: 'error' }))
    }
};

export const registerUser = (user) => async (dispatch) => {
    dispatch(registerRequest());

    try {
        await userService.registerUser(user);
        dispatch(openSnackBar({ message: `We've sent an email to ${user.email}. Please Check your email to verify and continue.`, status: 'success' }));
        dispatch(registerEnd());
    } catch (error) {
        dispatch(registerEnd());
        dispatch(openSnackBar({ message: error.message, status: 'error' }))
        throw new Error(error);
    }
};

export const resetUser = (email, from) => async (dispatch) => {
    try {
        await userService.reset(email);
        dispatch(openSnackBar({ message: `Sent reset email to the ${email}!`, status: 'info' }));
    } catch (error) {
        dispatch(openSnackBar({ message: error.message, status: 'error' }))
        throw new Error(error);
    }
};

export const resetUserPwd = (token, password, from) => async (dispatch) => {
    try {
        await userService.resetpwd(token, password);
        dispatch(openSnackBar({ message: `Successfully reset password!`, status: 'info' }));
    } catch (error) {
        dispatch(openSnackBar({ message: error.message, status: 'error' }))
        throw new Error(error);
    }
};

export const verifyUser = (token, from) => async (dispatch) => {
    try {
        await userService.verifyUser(token);
        dispatch(openSnackBar({ message: `Successfully verified the user!`, status: 'info' }));
        
    } catch (error) {
        dispatch(openSnackBar({ message: error.message, status: 'error' }))
        throw new Error(error);
    }
}

//selectors
export const selectLogingIn = (state) => state.authState.loggingIn;
export const selectLoggedIn = (state) => state.authState.loggedIn;
export const selectUserToken = (state) => state.authState.userToken;

export default authSlice.reducer;